
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/face",
      function () {
        return require("private-next-pages/face/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/face"])
      });
    }
  